module.exports = "\r\n<div style=\"min-height:640px;width:96%\" class=\"container\">\r\n  <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/contentarea/contentarea.component.html
// module id = ./src/app/layout/contentarea/contentarea.component.html
// module chunks = main